var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('preview-zoom-dialog',{attrs:{"dialogType":_vm.dialogType,"imageSrc":_vm.imageSrc,"dialogFile":_vm.dialogFile,"dialogFileMlUrl":_vm.dialogFileMlUrl,"name":_vm.imageName},on:{"close-dialog":_vm.closePreviewZoomDialog}})}
var staticRenderFns = []

export { render, staticRenderFns }